import React, { useRef, useCallback } from 'react';
import './Footer.css';
import { Button } from './Button';
import { Link } from 'react-router-dom';

function Footer() {
  const footerLetterRefs = useRef([]);
  const FOOTER_LOGO_CHARS = 'coretez.io'.split('');
  const MAX_SCALE = 1.6;
  const INFLUENCE_RADIUS = 80;

  const handleFooterLogoMouseMove = useCallback((e) => {
    const mouseX = e.clientX;
    footerLetterRefs.current.forEach((el) => {
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const letterCenterX = rect.left + rect.width / 2;
      const dist = Math.abs(mouseX - letterCenterX);
      const scale = dist < INFLUENCE_RADIUS
        ? 1 + (MAX_SCALE - 1) * Math.cos((dist / INFLUENCE_RADIUS) * (Math.PI / 2))
        : 1;
      el.style.transform = `scale(${scale})`;
    });
  }, []);

  const handleFooterLogoMouseLeave = useCallback(() => {
    footerLetterRefs.current.forEach((el) => {
      if (el) el.style.transform = 'scale(1)';
    });
  }, []);
  return (
    <div className='footer-container'>
      <section className='footer-subscription'>
        <p className='footer-subscription-heading'>
          Sign up to recieve my latest news & updates on all things Microsoft Azure and our tools as they develop
        </p>
        <p className='footer-subscription-text'>
          You can unsubscribe at any time.
        </p>
        <div className='input-areas'>
          <form>
            <input
              className='footer-input'
              name='email'
              type='email'
              placeholder='Your Email'
            />
            <Button buttonStyle='btn--outline'>Subscribe</Button>
          </form>
        </div>
      </section>
      <div className='footer-links'>
        <div className='footer-link-wrapper'>
          <div className='footer-link-items'>
            <h2>About Us</h2>
            <Link to='/'>What is Coretez?</Link>
            <Link to='/'>Terms of Service</Link>
            <Link to='/'>Privacy Policy</Link>
          </div>
          <div className='footer-link-items'>
            <h2>Contact Us</h2>
            <a href="mailto:info@coretez.io">Contact</a>
          </div>
        </div>
        <div className='footer-link-wrapper'>
          <div className='footer-link-items'>
            <h2>Social Media</h2>
            <Link to='/'>Instagram</Link>
            <Link to='/'>Facebook</Link>
            <Link to='/'>Youtube</Link>
            <Link to='/'>X</Link>
          </div>
        </div>
      </div>
      <section className='social-media'>
        <div className='social-media-wrap'>
          <div className='footer-logo'>
            <Link to='/' className='social-logo'>
              <span
                className='footer-logo-text'
                onMouseMove={handleFooterLogoMouseMove}
                onMouseLeave={handleFooterLogoMouseLeave}
              >
                {FOOTER_LOGO_CHARS.map((char, i) => (
                  <span
                    key={i}
                    className='footer-logo-char'
                    ref={el => footerLetterRefs.current[i] = el}
                  >
                    {char === ' ' ? ' ' : char}
                  </span>
                ))}
              </span>
            </Link>
          </div>
          <small className='website-rights'>coretez.io © 2026</small>
          <div className='social-icons'>
            <Link
              className='social-icon-link facebook'
              to='/'
              target='_blank'
              aria-label='Facebook'
            >
              <i className='fab fa-facebook-f' />
            </Link>
            <Link
              className='social-icon-link instagram'
              to='/'
              target='_blank'
              aria-label='Instagram'
            >
              <i className='fab fa-instagram' />
            </Link>
            <Link
              className='social-icon-link youtube'
              to='/'
              target='_blank'
              aria-label='Youtube'
            >
              <i className='fab fa-youtube' />
            </Link>
            <Link
              className='social-icon-link x-twitter'
              to='/'
              target='_blank'
              aria-label='X'
            >
              <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' style={{ width: '1em', height: '1em', fill: 'currentColor' }}>
                <path d='M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.253 5.622 5.912-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z' />
              </svg>
            </Link>
            <Link
              className='social-icon-link twitter'
              to='/'
              target='_blank'
              aria-label='LinkedIn'
            >
              <i className='fab fa-linkedin' />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;
